import React from "react";

function Header() {
  return (
    <>
      <div
        className="container col-md-6 col-md-12"
        style={{
          backgroundColor: "lightblue",
          color: "blue",
          textAlign: "center",
        }}
      >
        <h1>SMART JOB PORTAL</h1>
      </div>
    </>
  );
}

export default Header;
